import React, { Component } from 'react';
import ConsoleTile from 'components/shared/ConsoleTile/ConsoleTile';
import { DeviceChartView } from 'components/features/DeviceChartView';
import DeviceQuickView from 'components/features/DeviceQuickView/DeviceQuickView';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Map, Marker, TileLayer } from 'react-leaflet';
import DeviceConfigTable from 'components/features/DeviceConfigTable/DeviceConfigTable';
import {
  updateSingleDevicePageSelectedDevice,
  getSingleDevice,
  getDevicesIds,
  doFetchAlarms,
  storeAllDeviceAlarms,
  updateDevicesIds,
  updateDevicesPageActiveTab
} from 'redux/actions';
import {
  getDeviceIndexByID,
  deviceToProductTypeDisplayString,
  distillProductType,
  isObjectEmpty
} from 'common/utils/helpers';
import DeviceVersionView from 'components/features/DeviceVersionView/DeviceVersionView';
import SingleDeviceSearchBar from 'components/features/SingleDeviceSearchBar/SingleDeviceSearchBar';
import AlarmTable from 'components/features/AlarmTable/AlarmTable';
import CommissionWidget from 'components/features/Commissioning/CommissionWidget/CommissionWidget';
import { Status, BLINK_DEVICE_LED_MIN_API_VERSION, DEVICES_PAGE_TAB } from 'common/utils/constants';
import { deviceIcon } from 'common/deviceMapIcons';
import { ErrorBox } from 'components/shared/ErrorBox/ErrorBox';
import RfController from 'components/features/RfController/RfController';
import CommentsWidget from 'components/features/Comments/CommentsWidget/CommentsWidget';
import LEDBar from 'components/features/LEDBar/LEDBar';
import './SingleDevicePage.css';
import { ReturnButton } from 'components/shared/ReturnButton/ReturnButton';
import MapZoomOverlay from './MapZoomOverlay';

class SingleDevicePage extends Component {
  constructor(props) {
    super(props);
    this.deviceIndex = -1;

    this.state = {
      deviceGetFailed: false /* Keep track of whether get device failed, used for making sure the error message doesn't disappear and reappear when
                                   we retry the get device call and the status briefly goes back to PENDING */,

      commentsBoxPermissions: false,
      commissionPermissions: false, //TODO
      alarms: null
    };

    this.mapKey = 0; //increment this to force rerender if map ends up minimized.
    this.mapRef = React.createRef();

    this.mapZoomHandle = this.mapZoomHandle.bind(this);
    this.validApiVersion = this.validApiVersion.bind(this);
  }

  updateSelectedDevice() {
    const { devices, dispatch, selectedDevice } = this.props;
    if (this.deviceIndex !== -1) {
      if (devices[this.deviceIndex]) {
        dispatch(updateSingleDevicePageSelectedDevice(devices[this.deviceIndex]));
      } else {
        dispatch(updateSingleDevicePageSelectedDevice(selectedDevice));
      }
      // dispatch(updateSingleDevicePageSelectedDevice(devices[this.deviceIndex]));
      // dispatch(updateSingleDevicePageSelectedDevice(selectedDevice));
    } else {
      // dispatch(updateSingleDevicePageSelectedDevice(null));
      dispatch(updateSingleDevicePageSelectedDevice(selectedDevice));
    }
  }

  fetchAlarms = (deviceID) => {
    this.props.dispatch(
      doFetchAlarms(
        [deviceID], // deviceIDs,
        null,
        null,
        ['active'],
        null,
        null,
        1000,
        null,
        ['severity'],
        (result) => {
          this.props.dispatch(storeAllDeviceAlarms(result));
        },
        (error) => {
          console.log('doFetchAlarmserror', error);
        },
        []
      )
    );
  };

  componentWillUnmount() {
    this.props.dispatch(updateSingleDevicePageSelectedDevice(null));
    if (this.pollDeviceTimeout != null) {
      clearInterval(this.pollDeviceTimeout);
    }

    if (this.hideCheckTimeout != null) {
      clearTimeout(this.hideCheckTimeout);
    }
  }

  componentDidMount() {
    const {
      props: { devices, devicesIds, dispatch, statuses, permissions, fetchAlarmsStatus, location },
      state: { commissionPermissions, commentsBoxPermissions }
    } = this;
    let deviceId = location.search.substring(1);

    // uncomment below only if either devices page or single device page fetches all devices page when user logs into either page
    // if (isObjectEmpty(devices)) dispatch(searchFilteredDevices());

    if (isObjectEmpty(devicesIds)) {
      if (isObjectEmpty(devices)) {
        dispatch(getDevicesIds()); // fetch all devices IDs from _search API for single device page search bar
      } else {
        let devicesIds = devices.map((device) => device.id);
        dispatch(updateDevicesIds(devicesIds)); // just extract all devices IDs when all devices have been fetched
      }
    }

    if (fetchAlarmsStatus == null) this.fetchAlarms(deviceId);

    // this.updateSelectedDevice();
    dispatch(getSingleDevice(deviceId)); //do a single get device when single device page is loaded
    this.updateSelectedDevice();

    // getSupportedCommissioningSoftwareVersions().then(result => {
    //   this.setState({supportedSoftwareVersions: result.versions});
    // });

    if (!commissionPermissions && permissions && permissions.includes('cm_commission')) {
      this.setState({ commissionPermissions: true });
    }

    if (!commentsBoxPermissions && permissions && permissions.includes('cm_comments')) {
      this.setState({ commentsBoxPermissions: true });
    }

    /* update device every 15 seconds */
    this.pollDeviceTimeout = setInterval(() => {
      if (statuses['GET-' + deviceId] !== Status.PENDING) dispatch(getSingleDevice(deviceId));
      if (fetchAlarmsStatus == null) this.fetchAlarms(deviceId);
    }, 15000);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      props: { devices, dispatch, statuses, selectedDevice, location },
      state: { deviceGetFailed }
    } = this;
    let deviceId = location.search.substring(1);
    let getDeviceStatus = statuses['GET-' + deviceId];

    if (deviceId !== prevProps.location.search.substring(1)) {
      if (devices?.[this.deviceIndex]) {
        dispatch(updateSingleDevicePageSelectedDevice(devices[this.deviceIndex]));
      } else {
        dispatch(getSingleDevice(deviceId));
      }

      clearInterval(this.pollDeviceTimeout);
      this.pollDeviceTimeout = setInterval(() => {
        if (getDeviceStatus !== Status.PENDING) dispatch(getSingleDevice(deviceId));
      }, 15000);
    }

    if (this.deviceIndex > 0 && devices?.[this.deviceIndex] !== selectedDevice) {
      this.updateSelectedDevice();
    }

    /* Hacky way to fix that stupid map sometimes coming up with no hieght*/
    if (this.mapRef && this.mapRef.current && this.mapRef.current.container.clientHeight < 1) {
      //console.log("current:", this.mapRef.current);
      this.mapKey++;
      this.setState({ dummy: null });
    }

    if (getDeviceStatus === Status.FAILURE && !deviceGetFailed) this.setState({ deviceGetFailed: true });

    if (getDeviceStatus === Status.SUCCESS && deviceGetFailed) this.setState({ deviceGetFailed: false });
  }

  mapZoomHandle(direction) {
    const map = this.mapRef.current.leafletElement;

    if (direction === 'in') {
      map.zoomIn();
    } else if (direction === 'out') {
      map.zoomOut();
    }
  }

  /**
   * @param {number} minVersion minimum IBMS API version required
   * @returns true if current device's IBMS API version is at least min version
   */
  validApiVersion(minVersion) {
    const deviceVersion = this.props.selectedDevice?.properties?.reported?.ibmsApiVersion;
    // treat as v0 if device does not have property ibmsApiVersion
    if (deviceVersion === undefined) {
      return 0 >= minVersion;
    }

    return parseInt(deviceVersion.substring(1)) >= minVersion;
  }

  render() {
    /* Make sure that device id in url matches id. This allows switching devices smoothly without having to force the page to refresh*/
    const {
      props: { devices, location, selectedDevice, permissions, dispatch },
      state: { deviceGetFailed, commissionPermissions, commentsBoxPermissions }
    } = this;
    let deviceId = location.search.substring(1);
    let pageLoadingOverlay = (
      <div className="loadingPanel">
        <svg className="spinner" viewBox="0 0 50 50">
          <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
        </svg>
      </div>
    );

    if (this.deviceIndex === -1 || deviceId !== devices[this.deviceIndex].id) {
      this.deviceIndex = getDeviceIndexByID(deviceId, devices);
    }

    if (devices != null && devices.length > 0) {
      if (this.deviceIndex === -1) {
        // console.log("device not found:", deviceId, "\n Device List:", devices);
        /* TODO: handle non-existing devices */
        //return <Redirect to="/error" />
      }
    }

    /* This will force single device page components to unmount and remount when switching devices. This fixes issues with components that
         expected to be mounted with either the correct device or null, or components that need to stop timers on unmount */
    if (selectedDevice != null && deviceId !== selectedDevice.id) {
      return pageLoadingOverlay; // loading presents when getDeviceById API is calling
    }

    // let device = this.deviceIndex !== -1 ? devices[this.deviceIndex] : null;
    let device = selectedDevice;
    let map = null;

    /* For some reason, importing the svg and using it as an img src didn't work here. No explanation as to why, but copying and pasting the contents of the svg works fine */

    /* this section broughtt in after above comment, and unrelated*/

    let deviceType = null;

    const pivotTypes = ['donor', 'service'];

    if (device)
      deviceType = pivotTypes.includes(distillProductType(device.properties.reported.productType)) ? 'pivot' : 'echo';

    let divIcon = deviceIcon({
      className: 'DeviceMap_DivIcon',
      deviceType
    });

    map = (
      <div className="SingleDevicePage_Map_Div">
        <Map
          ref={this.mapRef}
          key={this.mapKey}
          style={{ height: '100%' }}
          center={{ lat: device?.location?.lat || 0, lng: device?.location?.lon || 0 }}
          zoom={10}
          zoomControl={false}
          dragging={false}
          keyboard={false}
          scrollWheelZoom={false}
        >
          <TileLayer
            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={{ lat: device?.location?.lat || 0, lng: device?.location?.lon || 0 }} icon={divIcon} />
        </Map>
        <MapZoomOverlay zoomHandler={this.mapZoomHandle} />
      </div>
    );

    let deviceNotFound = null;
    if (deviceGetFailed) {
      let message = (
        <div className="ErrorBox_Message">
          {' '}
          Cannot find device with ID "{deviceId}". For support, contact
          <a href="mailto:support@pivotalcommware.com"> support@pivotalcommware.com</a>
        </div>
      );
      deviceNotFound = (
        <div className="SingleDevicePage_GetDeviceError_Div">
          <ErrorBox message={message} />
        </div>
      );
    }

    return (
      <div className="SingleDevicePage pageStyle" key={deviceId + '-singleDevicePage'}>
        <ReturnButton
          text={'Return to All Devices'}
          route={'/console/devices'}
          action={() => dispatch(updateDevicesPageActiveTab(DEVICES_PAGE_TAB.all))}
        />
        <div className="SingleDevicePage_HeaderDiv">
          <span className="SingleDevicePage_HeaderDiv_Title">Single device</span>
          <div className="SingleDevicePage_HeaderDiv_ButtonRow">
            {commissionPermissions &&
              distillProductType(selectedDevice?.properties?.reported?.productType) === 'donor' && (
                <CommissionWidget device={device} />
              )}
            {commentsBoxPermissions && <CommentsWidget />}
          </div>
        </div>
        {deviceNotFound}
        <div className="rowFlexDiv">
          <div className="SingleDevicePage_Quick_Alarm_Col">
            <div className="DeviceQuickView_ContainerDiv">
              <DeviceQuickView
                device={this.deviceIndex !== -1 ? selectedDevice : null}
                id={deviceId}
                type={deviceToProductTypeDisplayString(device)}
                permissions={permissions}
                dispatch={dispatch}
              />
            </div>
            <div className="SingleDevicePage_AlarmTable_ContainerDiv">
              <ConsoleTile title="Alarms" type="AlarmTable">
                <AlarmTable deviceID={deviceId} />
              </ConsoleTile>
            </div>
          </div>
          <div className="SingleDevicePage_Search_Map_Col">
            <div className="DeviceSearchBar_OutlineDiv">
              <div className="DeviceSearchBar_ContainerDiv">
                <SingleDeviceSearchBar key={deviceId} parent={this} />
              </div>
            </div>
            <div className="SingleDevicePage_Map_ContainerDiv">
              <ConsoleTile title="Location">{map}</ConsoleTile>
            </div>
          </div>
        </div>
        <div className="rowFlexDiv">
          <div style={{ flex: '1 1 0%', margin: '0px 0px 16px 0px', maxWidth: '100%' }}>
            <DeviceChartView deviceId={deviceId} />
          </div>
        </div>
        <div className="rowFlexDiv">
          <div className="SingleDevicePage_SWVersion_Col_Div">
            <div style={{ maxHeight: '240px', backgroundColor: 'pink' }}>
              <DeviceVersionView key={deviceId + '-DeviceVersionView'} />
            </div>
          </div>

          <div className="SingleDevicePage_RfController_Div">
            <ConsoleTile title="5G RF Configuration">
              <RfController device={this.props.selectedDevice} />
            </ConsoleTile>
          </div>
        </div>
        <div className="rowFlexDiv">
          <div className="SingleDevicePage_DeviceConfigTable_Div">
            <DeviceConfigTable device={this.props.selectedDevice} />
          </div>
        </div>
        {selectedDevice &&
          permissions.includes('cm_post_led') &&
          this.validApiVersion(BLINK_DEVICE_LED_MIN_API_VERSION) && (
            <div className="rowFlexDiv">
              <div className="SingleDevicePage_LED_Div">
                <LEDBar deviceID={selectedDevice.deviceId} connectionState={selectedDevice.connectionState} />
              </div>
            </div>
          )}
        <div style={{ width: '100%', height: '50px' }} />
      </div>
    );
  }
}

export default withRouter(
  connect((store) => {
    return {
      devicesIds: store.data.devicesIds,
      selectedDevice: store.ui.singleDevicePage.selectedDevice,
      statuses: store.statuses,
      permissions: store.data.rolePermissions.permissions,
      fetchAlarmsStatus: store.statuses.fetchAlarms
    };
  })(SingleDevicePage)
);
